import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import SEOHead from "@/components/SEOHead";
import HomeApple, { HOME_FAQ } from "@/components/home/HomeApple";
import { useAuth } from "@/contexts/AuthContext";
import { generateWebsiteSchema } from "@/lib/structuredData";

const Index = () => {
  const [searchParams] = useSearchParams();
  const { user } = useAuth();

  // Store referral code in localStorage if present
  useEffect(() => {
    const refCode = searchParams.get("ref");
    if (refCode) {
      localStorage.setItem("perfectezorgmatch_ref", refCode);
    }
  }, [searchParams]);

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      // Organization staat één keer in index.html (@id …/#organization)
      (({ ["@context"]: _c, ...w }) => w)(generateWebsiteSchema()),
      {
        "@type": "FAQPage",
        mainEntity: HOME_FAQ.map(([q, a]) => ({
          "@type": "Question",
          name: q,
          acceptedAnswer: { "@type": "Answer", text: a },
        })),
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="PGB Marktplaats | De Perfecte Zorgmatch"
        description="De Perfecte Zorgmatch verbindt liefdevolle zorgverleners met cliënten. Meld je aan als zorgverlener."
        canonicalUrl="/"
        structuredData={structuredData}
      />
      {/* Ingelogd: de bestaande sitebrede balk (account, berichten, meldingen) blijft. */}
      <HomeApple nav={user ? <Navbar /> : undefined} />
    </>
  );
};

export default Index;
